import request from './request.js';
import Servers from '@config'

export default {
  // 已购买产品
  fetchProductInfo: request.get(Servers.oss + '/mall/product/info'),

  // 获取销售服务状态
  getServiceFlag: request.get(Servers.crm + '/api/ClientRead/OpenServiceSettingInfo'),

  // 设置使用销售服务
  fetchCrmOpenServiceSetting: request.post(Servers.crm + '/api/ClientWrite/OpenServiceSetting'),
}